import { first } from 'lodash/fp';

export const getSafelyUserRegion = ({ userRegion }) => (regions) => {
    const regionValues = Array.isArray(regions) ? regions : Object.keys(regions);

    // if the current region is none of the available ones we need to fall back to the first one
    if (userRegion && regionValues.some(value => value === userRegion)) {
        return userRegion;
    }

    return first(regionValues);
};
